import { getConfigDefaults } from "../api/configLoader.js";
import { setToken } from "../api/client.js";

export function isLabelsEmbedPathname() {
  try {
    const p = (window.location.pathname || "").replace(/\/$/, "").toLowerCase();
    return p === "/embed/labels";
  } catch {
    return false;
  }
}

export async function loadLabelsEmbedBootstrap(token) {
  const base = getConfigDefaults();
  const apiUrl = `${window.location.origin.replace(/\/$/, "")}/api`;
  const res = await fetch(`${apiUrl}/nitromule/v1/embed/labels-bootstrap`, {
    credentials: "omit",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json"
    }
  });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      if (j?.message) msg = j.message;
      if (j?.code === "UNAUTHORIZED") msg = j.message || "Unauthorized";
    } catch {}
    const err = new Error(msg);
    err.code = res.status === 401 ? "UNAUTHORIZED" : "UNKNOWN";
    throw err;
  }
  const data = await res.json();
  setToken(token);
  window.nitromuleReactData = {
    ...base,
    ...data,
    token,
    apiUrl,
    userLoggedIn: true,
    labelsEmbed: true
  };
  return window.nitromuleReactData;
}
